import moment from "moment";
import { icons } from "../../assets/icons";

export const groupsListColumns = (deleteGroup, navigate, isGroupNameClickable = true, editGroup ) => [
  { 
    Header: "Group Name", 
    accessor: "name",
    Cell: (props) => {
      if(isGroupNameClickable){
        return (
          <div
            className={`cursor-pointer ${Object.keys(props?.row?.original?.groupUsers || {}).length > 0 ? 'underline' : ''} underline-offset-4`}
            style={{color: Object.keys(props?.row?.original?.groupUsers || {}).length > 0 ? 'blue' : ''}}
            onClick={() => {
              navigate(`/groups/description`, { state: props?.row?.original || {} });
            }}
          >
            {props?.row?.original?.name || ""}
          </div>
        );
      } else {
        return (
          <div
          >
            {props?.row?.original?.name || ""}
          </div>
        );
      }
    },
  },
  // {
  //   Header: "Creation On",
  //   accessor: "added",
  //   Cell: (props) => {
  //     return (
  //       <div>{props?.row?.original?.added || ""}</div>
  //     );
  //   },
  // },
  // {
  //   Header: "Assign To",
  //   accessor: "groups",
  //   Cell: (props) => {
  //     return <div>{props?.row?.original?.groupIds?.length || 0}</div>;
  //   },
  // },
  // {
  //   Header: "Updated",
  //   accessor: "updated",
  //   Cell: (props) => {
  //     return (
  //       <div>{props?.row?.original?.updated || ""}</div>
  //     );
  //   },
  // },
  // {
  //   Header: "Status",
  //   accessor: "actions",
  //   Cell: (props) => {
  //     if(isGroupNameClickable){
  //       return (
  //         <div className="flex items-center gap-x-10 cursor-pointer">
  //           <img src={icons.editIcon} onClick={() => editGroup(props?.row?.original)} />
  //           <img src={icons.trashIcon} onClick={() => deleteGroup(props?.row?.original.id)} />
  //           {/* <img src={icons.trashIcon} /> */}
  //         </div>
  //       );
  //     }
  //   },
  // },
];
